<ng-container *ngIf="shippingAccounts">
  <h4>{{ 'checkout.checkoutShippingAccounts.title' | cxTranslate }}</h4>
  <p class="select-account-text">{{ 'checkout.checkoutShippingAccounts.selectAccount' | cxTranslate }}</p>
  <div class="shipping-account-selector-wrap">
    <div class="shipping-accounts-selector">
      <ng-select
        id="shipping-accounts-select"
        class="shipping-accounts-select"
        bindLabel="name"
        bindValue="code"
        [searchable]="false"
        [clearable]="false"
        [items]="shippingAccounts"
        (change)="changeShippingAccount($event.code)"
        [(ngModel)]="shippingAccountSelected"
        [ngModelOptions]="{standalone: true}">
      </ng-select>
    </div>
  </div>
  <p *ngIf="dealerShippingAccountsError" class="select-account-error">
    <span>{{ 'checkout.checkoutShippingAccounts.error' | cxTranslate }}</span>
  </p>
</ng-container>